import {
  getCustomerMarketKey,
  getSourceMarketId,
  getInplayV2SelectionStrictStableKey,
} from '../../../_helpers/inplayMarketIdentity.js';

const _normalizeToken = (value) => String(value ?? '').trim().toLowerCase().replace(/\s+/g, '');

const _cleanLine = (value) => String(value ?? '').replace(/\s*\(0-0\)\s*$/, '').trim();

const _getSelectionLineKey = (selection) => {
  const raw = selection?._sourceLine
    ?? selection?.line
    ?? selection?.display_line
    ?? selection?._sourceBaseLine
    ?? selection?.base_line
    ?? '';
  return _normalizeToken(_cleanLine(raw));
};

const _getSelectionDupKey = (selection) => {
  const stableKey = getInplayV2SelectionStrictStableKey(selection);
  if (stableKey) return stableKey;
  const nameKey = _normalizeToken(selection?.name_ko || selection?.name || '');
  const lineKey = _getSelectionLineKey(selection);
  return `${nameKey || `id:${selection?.id || ''}`}::${lineKey}`;
};

const _getSelectionStateRank = (selection, oddsLatest, marketLatest) => {
  const oddsSuspended = oddsLatest?.[selection.id]?.is_suspended ?? selection.is_suspended;
  const customerMarketKey = getCustomerMarketKey(selection);
  const sourceMarketId = getSourceMarketId(selection);
  const marketSuspended = marketLatest?.[customerMarketKey]?.is_suspended
    ?? marketLatest?.[sourceMarketId]?.is_suspended
    ?? selection._sourceMarketSuspended
    ?? false;
  return oddsSuspended || marketSuspended ? 1 : 0;
};

const _getSelectionUpdatedAt = (selection) => new Date(selection?.updated_at || 0).getTime();

const _sortSelectionCandidates = (items, oddsLatest, marketLatest) => {
  items.sort((a, b) => {
    const aState = _getSelectionStateRank(a, oddsLatest, marketLatest);
    const bState = _getSelectionStateRank(b, oddsLatest, marketLatest);
    if (aState !== bState) return aState - bState;

    const aUpdatedAt = _getSelectionUpdatedAt(a);
    const bUpdatedAt = _getSelectionUpdatedAt(b);
    if (aUpdatedAt !== bUpdatedAt) return bUpdatedAt - aUpdatedAt;

    return Number(b.id || 0) - Number(a.id || 0);
  });
  return items;
};

export const dedupeMergedSelections = (selections, oddsLatest = {}, marketLatest = {}) => {
  if (!Array.isArray(selections) || selections.length <= 1) return Array.isArray(selections) ? selections : [];

  // Backend/detail 응답이 같은 selection id를 중복으로 내보내는 경우가 있어
  // React key 충돌을 막기 위해 id 기준으로 한 번 먼저 정규화한다.
  const uniqueById = [];
  const idGroups = new Map();
  for (const selection of selections) {
    const selectionId = selection?.id;
    if (selectionId === null || selectionId === undefined || selectionId === '') {
      uniqueById.push(selection);
      continue;
    }

    const key = String(selectionId);
    if (!idGroups.has(key)) idGroups.set(key, []);
    idGroups.get(key).push(selection);
  }

  const normalizedSelections = [...uniqueById];
  for (const items of idGroups.values()) {
    normalizedSelections.push(_sortSelectionCandidates(items, oddsLatest, marketLatest)[0]);
  }

  const groups = new Map();
  for (const selection of normalizedSelections) {
    const key = _getSelectionDupKey(selection);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(selection);
  }

  const kept = [];
  for (const items of groups.values()) {
    kept.push(_sortSelectionCandidates(items, oddsLatest, marketLatest)[0]);
  }

  return kept;
};
